import validate from '../../../services/reduxValidate.js'
import {clearanceTypes} from '../../../../shared/services/clearanceConstants.js'

export default function(data, props) {
  const constraints = {
    status: {
      presence: {allowEmpty: false}
    }
  }

  switch (props.selectedType) {
  case clearanceTypes.defense.value:
    constraints.level = {presence: {allowEmpty: false}}
    constraints.scope = {presence: {allowEmpty: false}}
    break
  case clearanceTypes.radiation_protection.value:
    constraints.category = {presence: {allowEmpty: false}}
    break
  case clearanceTypes.site_access.value:
    constraints.operatingSite = {
      presence: {allowEmpty: false},
      length: {maximum: 255}
    }
    break
  }

  return validate(data, constraints)
}
